











import Vue, { PropType } from 'vue';

type IconType = 'print' | 'default';

export default Vue.extend({
  props: {
    iconType: String as PropType<IconType>,
  },
});
